import React, {useMemo, useState} from 'react'
import TaskModel from "../../../../../models/responses/task.model";
import {WorkPackage} from "../../../../../models/responses/work-package.model";
import {TaskContainer} from "../../FlowPage/components/Task/TaskContainer";
import {useDispatch} from "react-redux";
import {useActiveTaskSelector} from "../../../../../store/selectors/task/task.selectors";
import {useActiveProjectCalendarsSelector, useCpmMapSelector} from "../../../../../store/selectors/project.selectors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft, faAngleRight, faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import styles from "../WorkPackages.module.scss"

export default function WorkPackageTaskList (props: {
    tasks: TaskModel[],
    workPackage: WorkPackage,
    predecessorToggle: boolean,
    successorToggle: boolean,
    setPredecessorToggle: any,
    setSuccessorToggle: any,
    navigateToTask: (value: TaskModel) => void,
    selectNextTask: () => void,
}) {
    const dispatch = useDispatch();
    const activeTask = useActiveTaskSelector();
    const cpmMap = useCpmMapSelector();
    const projectCalendars = useActiveProjectCalendarsSelector();
    const [taskListOpen, setTaskListOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);

    const {
        predecessorToggle,
        successorToggle,
        setPredecessorToggle,
        setSuccessorToggle,
        selectNextTask,
        tasks,
        workPackage,
    } = props;

    const totalPages = useMemo(() => Math.ceil(tasks.length / 10), [tasks]);
    const itemsPerPage = 10;

    const renderItems = useMemo(() => {
        if (tasks.length > itemsPerPage) {
            if (tasks.length < (itemsPerPage * (page - 1))) {
                setPage(1);
            }
            return tasks.slice(
                (page - 1) * itemsPerPage,
                (page - 1) * itemsPerPage + itemsPerPage
            );
        }
        setPage(1);
        return tasks;
    }, [page, tasks]);

    const handlePrevClick = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextClick = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    const startItem = (page - 1) * itemsPerPage + 1;
    const endItem = Math.min(page * itemsPerPage, tasks.length);
    const stopEvents = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
    };

    return (
        <div>
            <div onClick={(e) => {
                stopEvents(e)
                setTaskListOpen(prevState => !prevState)
            }}
                className={styles.WorkPackageTasksHeader}>
                <span className={styles.WorkPackageTasksTitle}>
                    <FontAwesomeIcon icon={taskListOpen ? faChevronUp : faChevronDown} size={'lg'} />
                    <span className={styles.TaskHeader}>Tasks ({tasks.length === 0 ? '0' : tasks.length})</span>
                </span>
                <div className={styles.RightSideInfoContainer}>
                    {taskListOpen && <div className={styles.CustomPagination} onClick={stopEvents}>
                        <div className={styles.number}>
                            {startItem}-{endItem} of {tasks.length}
                        </div>
                        <button onClick={handlePrevClick} disabled={page === 1}>
                            <FontAwesomeIcon
                                style={{fontSize: "16px"}}
                                icon={faAngleLeft}
                            />
                        </button>
                        <button onClick={handleNextClick} disabled={page === totalPages}>
                            <FontAwesomeIcon
                                style={{fontSize: "16px"}}
                                icon={faAngleRight}
                            />
                        </button>
                    </div>}
                    {taskListOpen && <div className={styles.HeaderLabels}>
                        <span className={styles.DateHeader}>Start</span>
                        <span className={styles.DateHeader}>Finish</span>
                        <span className={styles.TargetHeader}>Target</span>
                        <span className={styles.DeadlineHeader}>Deadline</span>
                    </div>}
                </div>
            </div>
            {taskListOpen && renderItems.map((task, i) => (
                <div
                    className={styles.WorkPackageTaskContainer}
                    key={task.task_id}
                    id={task.task_id}
                    onClick={stopEvents}
                >
                    <TaskContainer
                        task={task}
                        index={i}
                        selectNextTask={selectNextTask}
                        calendarsMap={projectCalendars}
                        cpmTask={cpmMap.get(task.task_id)}
                        navigateToTask={props.navigateToTask}
                        goToPred={() => {}}
                        goToSuc={() => {}}
                        predecessorToggle={predecessorToggle}
                        successorToggle={successorToggle}
                        setPredecessorToggle={setPredecessorToggle}
                        setSuccessorToggle={setSuccessorToggle}
                    />
                </div>
            ))}
        </div>
    )
}